import React from 'react';
import ReactDOM from 'react-dom/client';
// import './assets/sass/main.scss';
// import './assets/sass/scss.scss';
// import './assets/sass/bootstrap.min.css';
import './assets/css/vendor/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fontsource-variable/inter';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'simple-line-icons/css/simple-line-icons.css';
import "./assets/css/sass/themes/gogo.light.yellowgranola.scss"
//  توکلت علی الحی الذی لایموت و الْحَمْدُ لِلَّهِ الَّذِی · الْمُلْکِ وَ لَمْ یَکُنْ لَهُ وَلِیٌّ مِنَ الذُّلِّ وَ کَبِّرْهُ تَکْبِیرا · الله اکبر · کبیرا کبیرا والحمدلله بکره واصیلا · اشهدان ...
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
